import type { IUseGetOptions, TFilter } from "@app/common/types";
import { QueryKeys } from "@app/propertyGroup/constants/QueryKeys";
import { getPropertyGroup } from "@app/propertyGroup/queries";
import { IPropertyGroup } from "@app/propertyGroup/types";
import { useMemo } from "react";
import { useInfiniteQuery } from "react-query";

export const useGetPropertyGroup = function(propertyGroupId: string | undefined, options?: IUseGetOptions & { filters?: TFilter }) {
    const { filters } = options || {};

    // Convert filter object to array of filter IDs that are selected (true)
    const selectedFilterIds = useMemo(() => {
        if (!filters) return undefined;
        return Object.entries(filters)
            .filter(([_, isSelected]) => isSelected === true)
            .map(([filterId]) => filterId);
    }, [filters]);

    return useInfiniteQuery<IPropertyGroup, Error>({
        queryFn: ({ pageParam = 1 }) => getPropertyGroup(propertyGroupId || "", pageParam, selectedFilterIds),
        queryKey: [QueryKeys.PropertyGroupItem, propertyGroupId, selectedFilterIds],
        getNextPageParam: (lastPage, pages) =>
            // return null if last page
            lastPage.has_more_data ? lastPage.current_page + 1 : null,
        staleTime: 1000 * 60 * 5, // 5 minutes
        ...options,
    });
};
